import {
  DoceboAuthorizerInterceptor,
  KeplerDoceboAuthorizerInterceptor,
  VoucherAuthorizerInterceptor,
  KeplerCredlyInterceptor,
  BeyondApiAuthorizationInterceptor,
} from './_index';

import { HTTP_INTERCEPTORS } from '@angular/common/http';

/**
 * Intercepter Providers array to used by the app.module.ts to reduce
 * configuration clutter
 */
export const IntercepterProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: KeplerDoceboAuthorizerInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: DoceboAuthorizerInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: VoucherAuthorizerInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: KeplerCredlyInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: BeyondApiAuthorizationInterceptor, multi: true },
];
